import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import isEmailValid from '../../../../../utils/isEmailValid';
import { EmailsObjectType } from '../../types';

export default function useExtractConsultEmails() {
  const [addExtractEmailModalShow, setAddExtractEmailModalShow] = useState(false);
  const [removeExtractEmailModalShow, setRemoveExtractEmailModalShow] = useState(false);
  const [extractEmails, setExtractEmails] = useState<EmailsObjectType[]>([]);
  const [extractEmailToAdd, setExtractEmailToAdd] = useState('');
  const [extractEmailToRemove, setExtractEmailToRemove] = useState('');
  const [originalExtractEmails, setOriginalExtractEmails] = useState<EmailsObjectType[]>([]);
  const [extractEmailOwnerNameToAdd, setExtractEmailOwnerNameToAdd] = useState('');

  const hasOriginalExtractEmailsChanged = useMemo((() => JSON.stringify(originalExtractEmails) !== JSON.stringify(extractEmails)), [originalExtractEmails, extractEmails]);
  const hasExtractEmailsToBeRendered = useMemo((() => extractEmails.length > 0), [extractEmails]);

  function handleExtractEmailToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setExtractEmailToAdd(event.target.value);
  }

  function handleExtractEmailOwnerNameToAddChange(event: ChangeEvent<HTMLInputElement>) {
    setExtractEmailOwnerNameToAdd(event.target.value);
  }

  const addExtractEmail = useCallback(() => {
    const onlyEmails = extractEmails.map((emailObj) => emailObj.email);
    const doesEmailAlreadyExists = onlyEmails.includes(extractEmailToAdd);
    if (doesEmailAlreadyExists) {
      toast.warn('Este e-mail já foi adicionado!');
      return;
    }
    if (!isEmailValid(extractEmailToAdd)) {
      toast.warn('E-mail inválido!');
      return;
    }
    setExtractEmails((prevState) => [...prevState, { email: extractEmailToAdd, emailOwnerName: extractEmailOwnerNameToAdd }]);
    setExtractEmailToAdd('');
    setExtractEmailOwnerNameToAdd('');
    toast.success('E-mail adicionado. Não se esqueça de salvar as alterações para confirmar');
  }, [extractEmailOwnerNameToAdd, extractEmailToAdd, extractEmails]);

  const removeExtractEmail = useCallback(() => {
    const filteredEmails = extractEmails.filter((email) => email.email !== extractEmailToRemove);
    setExtractEmails(filteredEmails);
    setRemoveExtractEmailModalShow(false);
    toast.success('E-mail removido. Não esqueça de salvar as configurações para aplicar as mudanças!');
    setExtractEmailToRemove('');
  }, [extractEmailToRemove, extractEmails]);

  const resetExtractEmails = useCallback(() => {
    setExtractEmails(originalExtractEmails);
    toast.info('Suas alterações foram desfeitas');
  }, [originalExtractEmails]);

  return {
    setAddExtractEmailModalShow,
    hasExtractEmailsToBeRendered,
    extractEmails,
    setExtractEmails,
    setExtractEmailToRemove,
    setRemoveExtractEmailModalShow,
    extractEmailToRemove,
    removeExtractEmail,
    addExtractEmailModalShow,
    extractEmailToAdd,
    handleExtractEmailToAddChange,
    addExtractEmail,
    removeExtractEmailModalShow,
    resetExtractEmails,
    hasOriginalExtractEmailsChanged,
    setOriginalExtractEmails,
    extractEmailOwnerNameToAdd,
    handleExtractEmailOwnerNameToAddChange,
  };
}
